module.exports = __webpack_public_path__ + "static/media/5.1.8c0f908a.jpg";